import { Box, VStack, Grid, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from "@chakra-ui/react";
import React, { useState } from "react";
import { VideoPlayer } from "./VideoPlayer";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";

type VideoModalProps = {
  isOpen: boolean;
  onClose: () => void;
  urls: string[];
}

export const VideoModal: React.FC<VideoModalProps> = ({ isOpen, onClose, urls }) => {
  const urlList = urls;
  const [index, setIndex] = useState(0);
  return (
    <Modal size="full" isCentered isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        bg="transparent"
        height="100%"
        w="100%"
      >
        <ModalHeader>
          <ModalCloseButton color="white" />
        </ModalHeader>
        <ModalBody w="100%" h="100%">
          <VStack alignItems="center" justifyItems="center" h="100%">
            {urlList.length ? <VideoPlayer url={urlList[index]} /> : <Box />}
            <Grid bg="black" autoFlow="column" w="100%" placeContent="space-between">
              {index !== 0
                ? <ChevronLeftIcon onClick={() => setIndex(index - 1)} fontSize="2em" color="white" />
                : <ChevronLeftIcon fontSize="2em" color="grey.200" />}
              {!!urlList[index + 1]
                ? <ChevronRightIcon onClick={() => setIndex(index + 1)} fontSize="2em" color="white" />
                : <ChevronRightIcon fontSize="2em" color="grey.200" />}
            </Grid>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}